// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Cube from 'cube-ui'
import store from './store'
import axios from 'axios'
import './common/css/reset.css'
import './common/stylus/index.styl'
import layer from 'vue-layer'
import {formatDate} from "./common/js/date";
import moment from 'moment/moment.js'
import VueLazyload from 'vue-lazyload'
import echarts from 'echarts'
import qs from 'qs'

Vue.filter('moment', function (value, formatString) {
  formatString = formatString || 'YYYY-MM-DD';
  return moment(value).format(formatString);
});

Vue.prototype.$echarts = echarts;

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: '../static/img/default.png',
  loading: '../static/img/default.png',
  lazyComponent:  true,
  throttleWait: 1000
})
Vue.use(Cube)
Vue.config.productionTip = false
Vue.prototype.layer = layer(Vue);
Vue.prototype.$qs = qs;

// http request 拦截器
axios.interceptors.request.use(
  config => {
    // 判断是否存在token，如果存在的话，则每个http header都加上token
    //console.log('axios——请求拦截器');
    let token = store.getters.token;
    //console.log(token);
    if (token != null && token != 'undefined') {
      console.log('将token放入请求头');
      config.headers.Authorization = token.authorizationToken;
    }
    if (localStorage.getItem('Authorization')) {
      config.headers.Authorization = localStorage.getItem('Authorization');
    }

    return config;
  },
  err => {
    return Promise.reject(err);
  }
);
//拦截器 格式化时间
Vue.filter('fmt', function (dt, fmt) {
  if (!dt && !fmt) return ''
  if (dt && !fmt) fmt = 'yyyy-MM-dd hh:mm:ss'
  let date = new Date(dt)
  return formatDate(date, fmt)
})

//拦截器 根据当前时间计算 剩余时间
Vue.filter('fmtd', function (date, dateAll) {
  if (!date && !dateAll) return ''
  if (date && !dateAll) {
    dateAll = 30//默认剩余时间30分钟
  }
  date = new Date(date).getTime();
  let dateNow = new Date().getTime();
  //计算相差的分钟数
  let minutes = Math.floor((dateNow - date)/(60*1000));
  if(minutes >= dateAll){
    return '已超时';
  }
  //计算分钟数后剩余的秒数
  var seconds=Math.floor((dateNow - date)%(60*1000));
  return minutes+":"+seconds;
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js